module.exports = __webpack_public_path__ + "img/noImageAvailable.12368abc.svg";